<template>
	<!-- New Doctor Item -->
	<div class="new-doctors__item-wrap main-border">

		<!-- Doc Item -->
		<div class="box flex clear_fix hr">

			<div class="box__avatar-wrap">
				<router-link :to="{name: 'SingleDoctor', query: {id: doctor._id}}" class="link_black">
					<user-avatar :data="doctor" :setClass="'box__avatar_doc-item user_fix'"></user-avatar>
				</router-link>
			</div>

			<div class="box__content box__stars">
				<h4 class="box__title box__title_doc-item underline">
					<router-link :to="{name: 'SingleDoctor', query: {id: doctor._id}}" class="link_black">
						{{doctor.last_name}} {{doctor.first_name}} {{doctor.middle_name}}
					</router-link>
				</h4>
				<div class="box__labels-wrap">
					<span class="box__label" v-for="item in doctor.specializations">{{item.name}}</span>
				</div>
				<div class="box__purpose-wrap" v-if="doctor.doctor_type">
					<span class="box__purpose-item" v-show="doctor.doctor_type.indexOf('childish') != -1">Детский</span>
					<span class="box__purpose-item" v-show="doctor.doctor_type.indexOf('adult') != -1">Взрослый</span>
				</div>
				<p class="box__paragraph bold">
					{{doctor.category}} {{doctor.degree}} {{doctor.experience}}
				</p>

				<rating :stars="doctor.mark" :reviewCount="doctor.mark_count"></rating>

			</div>

		</div>
		<!-- Doc Item End -->

		<!-- Doc Clinic -->
		<div class="box flex clear_fix hr" v-for="work in doctor.works">
			<div class="box__avatar-wrap">
				<router-link :to="{name: 'SingleClinic', query: {id: work.clinic_id}}" class="link_black fix">
					<user-avatar :data="work" :setClass="'box__avatar box__avatar_clinic'"></user-avatar>
				</router-link>
			</div>

			<div class="box__content box__content_clinic">
				<div class="box__title box__title_clinic">
					<router-link :to="{name: 'SingleClinic', query: {id: work.clinic_id}}" class="link_black">
						{{work.clinic_name}}
					</router-link>
				</div>

				<p class="box__paragraph">
					{{work.clinic_city.country.name}},
					{{work.clinic_city.region.name}},
					{{work.clinic_city.name}},
					ул. {{work.clinic_street}},
					{{work.clinic_house}}
				</p>

				<p class="box__paragraph">
					<span v-for="item in work.specializations">{{item.name}}</span>
				</p>
			</div>

			<create-visit-button :work="work" :appointment="appointment"></create-visit-button>

		</div>
		<!-- Doc Clinic End -->

	</div>
	<!-- New Doctor Item End -->
</template>

<script>
	import Rating from '../Stars/Rating.vue';
	import CreateVisitButton from '../CreateVisitButton.vue';

	export default {
		name: "DoctorThumbnail",
		props: ['doctor'],
		components: {Rating, CreateVisitButton},
		methods: {
			appointment(work) {
				this.$event.send('openAppointment', work)
			}
		}
	}
</script>
<style></style>



// WEBPACK FOOTER //
// DoctorThumbnail.vue?c9ba4e58